import { ChevronRightIcon } from "@/edit/components/Icons";
import { useCallback, type FormEvent } from "react";

export function UnauthorizedPage() {
  const onSubmitCode = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Create a new FormData object from the submitted form
    const formData = new FormData(e.currentTarget);

    // Convert the FormData entries into a plain object
    const { code } = Object.fromEntries(formData.entries()) as { code: string };

    if (code) {
      window.location.replace(
        `/register?token=${encodeURIComponent(code.toLowerCase().trim())}`
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b text-lg from-slate-100 to-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="p-4 rounded-2xl bg-white border-2 border-black/10 shadow-lg">
          <h1 className="text-2xl font-bold text-black mb-2">
            🔒 Zugriff erforderlich
          </h1>
          <p className="text-black/70 mb-4">
            Um auf das Clan Board zuzugreifen, musst du dein Gerät zuerst
            registrieren.
          </p>

          <div className="p-4 rounded-xl bg-blue-50 border border-blue-100 text-left mb-4">
            <h3 className="font-semibold text-blue-800 mb-2">Schritte:</h3>
            <ol className="text-blue-700 space-y-2">
              <li className="flex gap-2">
                <span className="font-bold">1.</span>
                <span>
                  In den Einstellungen unter Allgemein auf "Gerät hinzufügen"
                  klicken
                </span>
              </li>
              <li className="flex gap-2">
                <span className="font-bold">2.</span>
                <span>
                  Scanne den QR-Code mit deinem Gerät oder tippe den Code unten
                  ein
                </span>
              </li>
              <li className="flex gap-2">
                <span className="font-bold">3.</span>
                <span>Gib deinem Gerät einen Namen und registriere es</span>
              </li>
            </ol>
          </div>

          <form
            onSubmit={onSubmitCode}
            className="flex p-2 rounded-xl gap-1 bg-teal-50 border border-teal-100"
          >
            <input
              type="text"
              name="code"
              placeholder="Code"
              className="flex-1 text-xl text-center placeholder:text-black/60"
            />
            <button type="submit" className="rounded-full p-1.5 bg-teal-700">
              <ChevronRightIcon className="w-5 h-5 text-white" />
            </button>
          </form>
        </div>

        <p className="text-black/40 mt-4">
          Bereits registriert? Versuche die Seite neu zu laden.
        </p>

        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-6 py-2 rounded-xl bg-black/5 hover:bg-black/10
            text-black/70 transition-colors"
        >
          Seite neu laden
        </button>
      </div>
    </div>
  );
}
